var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorkingAtHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.882,
    x2: 443.314,
    y1: 192.718,
    y2: 397.15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.109,
    x2: 359.595,
    y1: 208.302,
    y2: 208.302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268b4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.737,
    x2: 475.615,
    xlinkHref: "#lg1",
    y1: 83.828,
    y2: 151.706
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.253,
    x2: 150.131,
    xlinkHref: "#lg1",
    y1: 280.318,
    y2: 348.196
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.466,
    x2: 155.687,
    y1: 135.932,
    y2: 179.153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 189.154,
    y2: 234.773
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 427,
    x2: 369.965,
    xlinkHref: "#lg2",
    y1: 208.302,
    y2: 208.302
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.382,
    x2: 419.347,
    xlinkHref: "#lg1",
    y1: 34.218,
    y2: 373.183
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 -1 2638 414.47)",
    gradientUnits: "userSpaceOnUse",
    x1: 2218.1,
    x2: 2538.201,
    xlinkHref: "#lg1",
    y1: 40.737,
    y2: 360.838
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.175,
    x2: 447.675,
    xlinkHref: "#lg2",
    y1: 367.312,
    y2: 389.812
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 326.046,
    y2: 440.82
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.608,
    x2: 374.83,
    y1: 376.771,
    y2: 376.771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fc123",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1348,
    stopColor: "#4bab2f",
    stopOpacity: 0.135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#468741",
    stopOpacity: 0.385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6201,
    stopColor: "#426e4e",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8318,
    stopColor: "#3f5e56",
    stopOpacity: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.564,
    x2: 192.903,
    xlinkHref: "#lg3",
    y1: 277.481,
    y2: 321.739
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.34,
    x2: 315.978,
    xlinkHref: "#lg3",
    y1: 282.162,
    y2: 319.881
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb9c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb5d4c"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.427,
    x2: 161.356,
    xlinkHref: "#lg4",
    y1: 153.786,
    y2: 183.716
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.712,
    x2: 382.594,
    xlinkHref: "#lg4",
    y1: 148.101,
    y2: 189.983
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.363,
    x2: 362.638,
    xlinkHref: "#lg4",
    y1: 171.714,
    y2: 171.714
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 188.605,
    y2: 245.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44f3e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#6d3326"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.051,
    x2: 277.449,
    xlinkHref: "#lg5",
    y1: 42.683,
    y2: 120.081
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.069,
    x2: 256.069,
    y1: 533.703,
    y2: 472.368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#883f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3326"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 454.343,
    y2: 479.299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.445,
    x2: 298.315,
    xlinkHref: "#lg1",
    y1: 275.785,
    y2: 444.543
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.36,
    x2: 241.298,
    y1: 380.06,
    y2: 335.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 413.113,
    y2: 449.505
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.643,
    x2: 222.928,
    xlinkHref: "#lg5",
    y1: 173.382,
    y2: 173.382
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.072,
    x2: 318.357,
    xlinkHref: "#lg5",
    y1: 173.382,
    y2: 173.382
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m473.707 4.6h-437.414c-18.006 0-32.602 14.596-32.602 32.601v343.278c0 17.996 14.596 32.591 32.601 32.591h437.415c18.006 0 32.601-14.596 32.601-32.591v-343.278c.001-18.005-14.595-32.601-32.601-32.601z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.354 4.067h-160.399c-6.603 0-11.955 14.595-11.955 32.601v343.278c0 17.996 5.352 32.591 11.955 32.591h160.399c6.603 0 11.955-14.596 11.955-32.591v-343.278c0-18.006-5.353-32.601-11.955-32.601z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.743 82.708c-3.751 0-7.361.599-10.743 1.703-3.618-11.803-14.6-20.386-27.589-20.386-15.934 0-28.852 12.917-28.852 28.852 0 2.302.271 4.541.781 6.688-13.599.959-24.333 12.293-24.333 26.135 0 14.471 11.731 26.202 26.202 26.202h64.534c19.108 0 34.597-15.49 34.597-34.597s-15.49-34.597-34.597-34.597z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.259 279.198c-3.751 0-7.361.599-10.744 1.703-3.618-11.803-14.6-20.386-27.588-20.386-15.934 0-28.852 12.917-28.852 28.852 0 2.302.271 4.541.781 6.688-13.599.959-24.333 12.293-24.333 26.135 0 14.471 11.731 26.202 26.202 26.202h64.534c19.107 0 34.597-15.49 34.597-34.597s-15.49-34.597-34.597-34.597z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.874,
    cy: 139.34,
    fill: "url(#SVGID_5_)",
    r: 65.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.262 184.086h475.476v49.498h-475.476z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.745 183.553h151.993v49.498h-151.993z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.92 1.6h-443.84c-18.27 0-33.08 14.81-33.08 33.08v348.32c0 18.26 14.81 33.07 33.08 33.07h443.84c18.27 0 33.08-14.81 33.08-33.07v-348.32c0-18.27-14.81-33.08-33.08-33.08zm.46 350.52c0 15.51-12.58 28.09-28.09 28.09h-388.58c-15.51 0-28.09-12.58-28.09-28.09v-286.57c0-15.51 12.58-28.08 28.09-28.08h388.58c15.51 0 28.09 12.57 28.09 28.08z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.48 401.61h425.04c17.22 0 31.19-13.97 31.19-31.19v-323.17c0-17.23-13.97-31.19-31.19-31.19h-425.04c-17.22 0-31.19 13.96-31.19 31.19v323.17c0 17.22 13.97 31.19 31.19 31.19zm-9.86-336.06c0-15.51 12.58-28.09 28.09-28.09h388.58c15.51 0 28.09 12.58 28.09 28.09v286.57c0 15.51-12.58 28.08-28.09 28.08h-388.58c-15.51 0-28.09-12.57-28.09-28.08z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.38 324.067v27.52c0 15.51-12.58 28.09-28.09 28.09h-63.29v35.86h90.92c18.27 0 33.08-14.81 33.08-33.07v-58.4z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m454.462 448.416h-398.924v-15.826c0-84.43 68.444-152.873 152.873-152.873h93.176c84.43 0 152.873 68.444 152.873 152.873v15.826z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 305.127v143.289h68.462v-15.826c0-53.223-27.205-100.086-68.462-127.463z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.057 271.342s-22.129 11.064-15.088 20.117c5.179 6.659 31.581 32.363 45.183 45.494 4.51 4.353 11.665 4.279 16.097-.153l29.751-29.75z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.943 271.342s22.129 11.064 15.088 20.117c-5.179 6.659-31.581 32.363-45.183 45.494-4.51 4.353-11.665 4.279-16.097-.153l-29.751-29.75z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.477 169.875c0-17.598 12.215-32.342 28.63-36.217 4.388-1.036 8.582 2.357 8.582 6.865v58.703c0 4.508-4.194 7.901-8.582 6.865-16.415-3.874-28.63-18.619-28.63-36.216z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.523 169.875c0-17.598-12.215-32.342-28.63-36.217-4.388-1.036-8.582 2.357-8.582 6.865v58.703c0 4.508 4.194 7.901 8.582 6.865 16.415-3.874 28.63-18.619 28.63-36.216z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 306.951c-59.447 0-107.638-48.191-107.638-107.637v-55.199c0-59.447 48.191-107.637 107.637-107.637 59.447 0 107.637 48.191 107.637 107.637v55.199c.002 59.446-48.189 107.637-107.636 107.637z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.946 226.386h-11.893c-9.911 0-17.415-8.956-15.679-18.714l6.817-38.324h29.616l6.817 38.324c1.737 9.758-5.767 18.714-15.678 18.714z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m159.784 164.727v-12.914c0-16.801 13.62-30.42 30.42-30.42h129.579c16.801 0 30.421 13.62 30.421 30.421v12.914c0 3.431 2.782 6.213 6.213 6.213 3.431 0 6.213-2.782 6.213-6.213v-118.899c0-23.837-19.324-43.162-43.162-43.162h-128.949c-23.837 0-43.161 19.324-43.161 43.161v118.899c0 3.431 2.782 6.213 6.213 6.213 3.431 0 6.213-2.782 6.213-6.213z",
    fill: "url(#SVGID_19_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m461.522 508.4h-410.906c-5.806 0-10.513-4.707-10.513-10.513v-25.481h431.932v25.481c0 5.806-4.707 10.513-10.513 10.513z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.154 478.884h-462.308c-2.972 0-5.381-2.409-5.381-5.381v-19.708c0-2.972 2.409-5.381 5.381-5.381h462.308c2.972 0 5.381 2.409 5.381 5.381v19.708c0 2.972-2.409 5.381-5.381 5.381z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.527 250.983h-277.054c-6.069 0-10.988 4.92-10.988 10.988v171.626c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-171.625c0-6.069-4.919-10.989-10.988-10.989z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 349.7,
    fill: "url(#SVGID_23_)",
    r: 26.436
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.485 386.333v47.264c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-47.264z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m207.285 193.035c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c0 8.64-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.715 193.035c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c-.001 8.64-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_26_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkingAtHome);
export default __webpack_public_path__ + "static/media/icon-working-at-home.7349aa4588269ca6e26edb26c3013cba.svg";
export { ForwardRef as ReactComponent };